import React, { useEffect, useState } from 'react';
import API from '../../api/API';
import { LinkGiocatore, LinkSquadra } from './Link';
import './StrisciaRecord.css';

/**
 * Le classifiche di sempre non hanno una pagina propria — è una scelta di perimetro, non una
 * dimenticanza. Restano queste due terne in cima a ciascun indice: bastano a far capire che
 * esiste uno storico, e ogni voce è la porta della scheda corrispondente.
 *
 * La striscia è contorno, non contenuto: se i record non arrivano sparisce in silenzio, perché
 * l'indice sotto è la ragione per cui si è aperta la pagina e deve restare leggibile comunque.
 */
export default function StrisciaRecord({ tipo }) {
  const [record, setRecord] = useState(null);

  useEffect(() => {
    let vivo = true;
    API.carriera.record()
      .then((r) => { if (vivo && r.isSuccess) setRecord(r.data); })
      .catch(() => { /* la striscia è contorno: l'indice si vede lo stesso */ });
    return () => { vivo = false; };
  }, []);

  if (!record) return null;

  const terne = tipo === 'squadre'
    ? [
        { titolo: 'Più mete fatte', voci: record.piuMeteFatte, squadra: true },
        { titolo: 'Più edizioni disputate', voci: record.piuEdizioni, squadra: true },
      ]
    : [
        { titolo: 'Più mete di sempre', voci: record.piuMete, squadra: false },
        { titolo: 'Più partite giocate', voci: record.piuPartite, squadra: false },
      ];

  return (
    <div className="record-striscia">
      {terne.map((t) => (
        <section className="record-blocco" key={t.titolo}>
          <h2 className="record-titolo">{t.titolo}</h2>
          <ol className="record-elenco">
            {(t.voci ?? []).map((v) => (
              <li key={v.id}>
                {t.squadra
                  ? <LinkSquadra slug={v.slug} nome={v.nome} />
                  : <LinkGiocatore id={v.id} nome={v.nome} cognome={v.cognome} />}
                <span className="record-valore">{v.valore}</span>
              </li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
}
